import { render, staticRenderFns } from "./leftbar.vue?vue&type=template&id=1aa67543&scoped=true&"
import script from "./leftbar.vue?vue&type=script&lang=js&"
export * from "./leftbar.vue?vue&type=script&lang=js&"
import style0 from "./leftbar.vue?vue&type=style&index=0&id=1aa67543&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa67543",
  null
  
)

export default component.exports